export default __webpack_public_path__ + "static/media/ecom1.131b9fee.png";